<script lang="ts">
    import { canadianProvinces, usStates } from 'wdom/services/country_data'

    import type { IContact, IAddress } from 'wdom/services/contacts'

    interface Props {
        contact: IContact | IAddress
    }

    let { contact }: Props = $props()

    let visual: string | undefined = $state()
    $effect(() => {
        if (contact.sp == null || contact.country == null) {
            visual = contact.sp
        } else if (contact.country == 'CA' && $canadianProvinces != null) {
            let found
            for (const item of $canadianProvinces) {
                if (item.code == contact.sp) {
                    found = item
                    break
                }
            }
            visual = found ? found.name : contact.sp
        } else if (contact.country == 'US' && $usStates != null) {
            let found
            for (const item of $usStates) {
                if (item.code == contact.sp) {
                    found = item
                    break
                }
            }
            visual = found ? found.name : contact.sp
        } else {
            visual = contact.sp
        }
    })
</script>

{#if visual}{visual}{/if}
